const {
  REACT_APP_BUILD_TARGET,
  REACT_APP_FACEBOOK_APP_ID,
  REACT_APP_GAMELOGIC_URL,
  REACT_APP_FIREBASE_API_KEY,
  REACT_APP_FIREBASE_PROJECT_ID,
  REACT_APP_FIREBASE_AUTH_DOMAIN,
  REACT_APP_FIREBASE_DATABASE_URL,
  REACT_APP_ONESIGNAL_APP_ID,
  REACT_APP_SENTRY_DSN,
  REACT_APP_SENTRY_RELEASE,
  REACT_APP_SENTRY_ENVIRONMENT,
  REACT_APP_IS_ADITION_DISABLED,
  REACT_APP_KICKER_AUTH_URL,
  REACT_APP_IS_STORE_DISABLED,
} = process.env

type AppConfig = {
  BUILD_TARGET: string
  GAMELOGIC_URL: string
  FACEBOOK_APP_ID: string
  FIREBASE_API_KEY: string
  FIREBASE_PROJECT_ID: string
  FIREBASE_AUTH_DOMAIN: string
  FIREBASE_DATABASE_URL: string
  ONESIGNAL_APP_ID: string
  SENTRY_DSN: string
  SENTRY_RELEASE: string
  SENTRY_ENVIRONMENT: string
  DEFAULT_BUDGET: number
  TEAM_SIZE: number
  IS_ADITION_DISABLED: boolean
  IS_KICKER_LOGIN_ENABED: boolean
  KICKER_AUTH_URL?: string
  IS_STORE_DISABLED?: boolean
}

const config: AppConfig = {
  BUILD_TARGET: REACT_APP_BUILD_TARGET!,
  GAMELOGIC_URL: REACT_APP_GAMELOGIC_URL!,
  FACEBOOK_APP_ID: REACT_APP_FACEBOOK_APP_ID!,
  FIREBASE_API_KEY: REACT_APP_FIREBASE_API_KEY!,
  FIREBASE_PROJECT_ID: REACT_APP_FIREBASE_PROJECT_ID!,
  FIREBASE_AUTH_DOMAIN: REACT_APP_FIREBASE_AUTH_DOMAIN!,
  FIREBASE_DATABASE_URL: REACT_APP_FIREBASE_DATABASE_URL!,
  ONESIGNAL_APP_ID: REACT_APP_ONESIGNAL_APP_ID!,
  DEFAULT_BUDGET: 16,
  TEAM_SIZE: 4,
  SENTRY_DSN: REACT_APP_SENTRY_DSN!,
  SENTRY_RELEASE: REACT_APP_SENTRY_RELEASE!,
  SENTRY_ENVIRONMENT: REACT_APP_SENTRY_ENVIRONMENT!,
  IS_ADITION_DISABLED: !!REACT_APP_IS_ADITION_DISABLED,
  KICKER_AUTH_URL: REACT_APP_KICKER_AUTH_URL,
  IS_KICKER_LOGIN_ENABED: !!REACT_APP_KICKER_AUTH_URL,
  IS_STORE_DISABLED: REACT_APP_IS_STORE_DISABLED === 'true',
}

export default config
